import React from 'react';
import { Icon } from 'src/components/atoms/Icon';

type UpDownIndicatorProps = {
  upOrDown: 'up' | 'down';
};

export const UpDownIndicator: React.FC<UpDownIndicatorProps> = ({
  upOrDown,
}) => {
  return (
    <>
      {upOrDown === 'up' ? (
        <Icon
          iconName="arrow-diagonal-up"
          height="20px"
          width="20px"
          ml=".5rem"
          color="icon.green"
        />
      ) : (
        <Icon
          iconName="arrow-diagonal-down"
          height="20px"
          width="20px"
          ml=".5rem"
          color="icon.red"
        />
      )}
    </>
  );
};
